import { OFFER_CATEGORY } from 'shared/constants/offer-categories';
import { Partner } from 'shared/enums/partner/partner.enums';
import { DealTileResponseDto } from 'shared/interfaces/deal/deal-tile-response.dto';
import { GameCardDataProps } from 'src/components/GameCard/GameCard';

export function mapDealTileResponseToGameCardData(dealTile: DealTileResponseDto): GameCardDataProps {
  const opensInDealView = dealTile.entryLink != null || dealTile.partnerId === Partner.Torox;

  return {
    cardType: 'deal',
    title: dealTile.name ?? '',
    points: dealTile.payoutPoints,
    xp: 0,
    rating: dealTile.rating ?? 0,
    imageUrl: dealTile.tileImage ?? dealTile.iconImage ?? undefined,
    osTypeId: dealTile.osTypeId ?? undefined,
    categories: dealTile.categories ?? [OFFER_CATEGORY.Deals],
    dealId: opensInDealView ? dealTile.dealId : undefined,
    partnerDealId: dealTile.partnerDealId ?? undefined,
    entryLink: dealTile.entryLink ?? undefined,
    actionLabel: 'View deal',
    isNew: dealTile.isNew === true,
  };
}
